export const ICON_THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  COLOR: 'color',
  FORM_ERROR: 'formError',
}

export const BUTTON_THEMES = {}
